import axios from 'axios';
import configService from '@/services/configService';

const baseUrl = () => `${configService.get('apiUrl')}/expense-request-block`;

export default {
  async list() {
    const response = await axios.get(baseUrl());
    return response.data;
  },
  async getOne({ id }) {
    const response = await axios.get(`${baseUrl()}/${id}`);
    return response.data;
  },
  async getByCompany({ company }) {
    const response = await axios.get(`${baseUrl()}/company/${encodeURIComponent(company)}`);
    return response.data;
  },
  async postOne({ setting }) {
    const response = await axios.post(baseUrl(), setting);
    return response.data;
  },
  async patchOne({ id, setting }) {
    const response = await axios.patch(`${baseUrl()}/${id}`, setting);
    return response.data;
  }
};
